import React, { useMemo } from "react";
import Search from "../SearchBox/Search";
import TableComp from "./TableComp";
import TableWrapper from "./TableWrapper";
import { filterTableRowsBySearch } from "../../utils/tableSearch";

const SearchableTable = ({
  setOpenDeleteModal,
  setOpenEditModal,
  setSelected,
  setOpenQtyAdjustModal,
  setOpenQtyLogModal,
  enableAccountLog,
  enableLoanDetail,
  onAddDiscount,
  onViewDiscountLog,
  onViewLedger,
  onOpeningBalance,
  onViewPayments,
  onAddPayment,
  onAddNonProductInvoice,
  CurrentData,
  setRows,
  Columns,
  SearchPlaceholder,
  SearchText,
  setSearchText,
  CurrentInvoice,
  SelectedCustomer,
  isLedger,
  disableSearch,
  onInvoiceUpdated,
}) => {
  const displayData = useMemo(() => {
    if (disableSearch || !Array.isArray(CurrentData)) return CurrentData ?? [];
    return filterTableRowsBySearch(CurrentData, SearchText, Columns);
  }, [CurrentData, SearchText, Columns, disableSearch]);

  return (
    <TableWrapper>
      {!disableSearch && (
        <Search
          Placeholder={SearchPlaceholder || "Search table..."}
          Value={SearchText}
          setValue={setSearchText}
        />
      )}
      <TableComp
        isLedger={isLedger}
        SelectedCustomer={SelectedCustomer}
        setOpenEditModal={setOpenEditModal}
        setOpenDeleteModal={setOpenDeleteModal}
        setSelected={setSelected}
        setOpenQtyAdjustModal={setOpenQtyAdjustModal}
        setOpenQtyLogModal={setOpenQtyLogModal}
        enableAccountLog={enableAccountLog}
        enableLoanDetail={enableLoanDetail}
        onAddDiscount={onAddDiscount}
        onViewDiscountLog={onViewDiscountLog}
        onViewLedger={onViewLedger}
        onOpeningBalance={onOpeningBalance}
        onViewPayments={onViewPayments}
        onAddPayment={onAddPayment}
        onAddNonProductInvoice={onAddNonProductInvoice}
        AllRows={displayData}
        Columns={Columns}
        setRows={setRows}
        CurrentInvoice={CurrentInvoice}
        onInvoiceUpdated={onInvoiceUpdated}
      />
    </TableWrapper>
  );
};

export default SearchableTable;
